<mat-card class="dashboard-calendar-widget">
  <mat-card-header *ngIf="showTitle">
    <div class="widget-header">
      <div class="header-title">
        <mat-icon>today</mat-icon>
        <span>Activități programate</span>
        <mat-chip class="today-count" *ngIf="todayCount > 0" color="primary">
          {{ todayCount }} astăzi
        </mat-chip>
      </div>
      
      <div class="header-actions">
        <button 
          mat-icon-button 
          (click)="refreshActivities()"
          matTooltip="Actualizează">
          <mat-icon>refresh</mat-icon>
        </button>
        
        <button 
          mat-icon-button 
          (click)="navigateToCalendar()"
          matTooltip="Deschide calendarul">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <!-- Loading State -->
    <div class="loading-container" *ngIf="isLoading">
      <mat-spinner diameter="30"></mat-spinner>
      <span>Se încarcă...</span>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && !hasUpcomingActivities">
      <mat-icon class="empty-icon">event_available</mat-icon>
      <p>Nu aveți activități programate în următoarele 7 zile.</p>
      <button 
        mat-stroked-button 
        color="primary" 
        (click)="navigateToCalendar()">
        <mat-icon>add</mat-icon>
        Programează activitate
      </button>
    </div>

    <!-- Activities List -->
    <div class="activities-list" *ngIf="!isLoading && hasUpcomingActivities">
      <div 
        class="activity-item"
        *ngFor="let activity of upcomingActivities; trackBy: trackByActivityId"
        (click)="navigateToActivity(activity)">
        
        <div class="activity-time">
          <div class="date">{{ formatDate(activity.scheduled_date) }}</div>
          <div class="time">{{ formatTime(activity.start_time) }}</div>
          <div class="countdown">{{ getTimeUntilActivity(activity) }}</div>
        </div>

        <div class="activity-content">
          <div class="activity-title">{{ activity.title }}</div>
          
          <div class="activity-details">
            <div class="detail-item" *ngIf="activity.activity_type">
              <mat-icon>category</mat-icon>
              <span>{{ activity.activity_type.name }}</span>
            </div>
            
            <div class="detail-item" *ngIf="activity.location">
              <mat-icon>place</mat-icon>
              <span>{{ activity.location }}</span>
            </div>
            
            <div class="detail-item" *ngIf="activity.participants_info">
              <mat-icon>people</mat-icon>
              <span>{{ activity.participants_info }}</span>
            </div>

            <div class="detail-item" *ngIf="activity.cerere_id">
              <mat-icon>folder</mat-icon>
              <span>Cerere #{{ activity.cerere_id }}</span>
            </div>
          </div>
        </div>

        <div class="activity-status">
          <span 
            class="status-indicator"
            [style.background-color]="getStatusColor(activity.status)"
            [matTooltip]="getStatusLabel(activity.status)">
          </span>
        </div>
      </div>

      <!-- View All Link -->
      <div class="view-all" *ngIf="upcomingActivities.length === maxItems">
        <button 
          mat-stroked-button 
          (click)="navigateToCalendar()"
          class="view-all-btn">
          <mat-icon>event</mat-icon>
          Vizualizează toate în calendar
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>